import React, { useEffect, useState } from 'react'
import ExhibitorsTable from '../modules/exhibitor/components/ExhibitorsTable'
import ControlPanel from '../utils/ControlPanel'
import { Box, Typography , TablePagination} from '@mui/material'
import AddExhibitorPopup from '../modules/exhibitor/components/ViewAddPopup'
import Button from '../ui/elements/buttons/Button'
import { useExhibitors } from "../modules/exhibitor/queries/useExhibitors";
import { Exhibitor } from "../modules/exhibitor/exhibitorType/Exhibitor";
import { SortField } from '../utils/schema/SortType'
import CircularLoader from '../ui/elements/loader/CircularLoader'
import { ExhibitorFilter } from '../utils/schema/ExhibitorFilter'

 
const Exhibitors: React.FC = () => {
  const [isExhibitor, setIsExhibitor] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
  const [sortFields, setSortFields] = useState<SortField[]>([{ field: "name", order: "asc" }]);
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState<ExhibitorFilter>();
  
  const { data: exhibitorsData, isLoading, refetch:refetchExhibitors } = useExhibitors({ sortFields, ...pagination ,searchText, filters }); 
  const exhibitors: Exhibitor[] = exhibitorsData?.data || []; 
  const totalPageCount = exhibitorsData?.pagination?.total;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPagination(prev => ({ ...prev, page: newPage + 1 }));
  };
  
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPagination({ page: 1, rowsPerPage: parseInt(event.target.value, 10) });
  };

  useEffect(() => {
  setPagination(prev => ({ ...prev, page: 1 }));
}, [searchText]);

  return (
    <Box m={2}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        pt={3}
        pb={1}
        sx={{
          rowGap: { xs: "10px" },
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
        }}
      >
        <Typography variant="h5" fontSize="34px" fontWeight={500}>
          Exhibitors
        </Typography>
      

        <ControlPanel pageType="exhibitors" isExhibitor={isExhibitor} setSearchText={setSearchText} exhibitors={exhibitors} searchText={searchText} filters={filters} setFilters={setFilters} />
      </Box>
      {isLoading ? <CircularLoader/> :
      <Box>
      <TablePagination
            component="div"
            count={totalPageCount || 0}
            page={pagination.page-1}
            onPageChange={handleChangePage}
            rowsPerPage={pagination.rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 15, 20, 25]}
          />
     
      <ExhibitorsTable exhibitors={exhibitors} refetchExhibitors={refetchExhibitors} />
      </Box>
}
    </Box>
  );
}

export default Exhibitors